import * as d3 from "d3";
import { useEffect, useRef } from "react";

import { getHours, getMinutes } from "@/config/date-fns";
import { design } from "@/config/design";

export function ClockPieChartHand() {
  const layerRef = useRef<SVGGElement>(null);

  useEffect(() => {
    if (!layerRef.current) return;

    const selection = d3.select(layerRef.current);

    // 初回のみレイアウト構築
    if (selection.selectAll("*").empty()) {
      selection
        .append("circle")
        .attr("class", "center-monitor")
        .attr("cx", 0)
        .attr("cy", 0)
        .attr("r", design.ClockPieChart.RADIUS * 0.25);

      selection.append("line").attr("class", "clock-hand-thick");
      selection.append("line").attr("class", "clock-hand-thin");

      selection
        .append("text")
        .attr("class", "digital-clock")
        .attr("text-anchor", "middle")
        .attr("dy", "0.35em")
        .style("font-size", "24px")
        .style("font-weight", "bold");
    }

    // 時計の更新関数
    const updateClock = () => {
      const now = new Date();
      const hours = getHours(now);
      const minutes = getMinutes(now);
      const angle = ((hours + minutes / 60) / 24) * 360;

      selection
        .select(".clock-hand-thick")
        .attr("x1", 0)
        .attr("y1", design.ClockPieChart.RADIUS * -0.2)
        .attr("x2", 0)
        .attr("y2", -design.ClockPieChart.RADIUS * 0.5)
        .attr("stroke-width", 12)
        .attr("transform", `rotate(${angle})`);

      selection
        .select(".clock-hand-thin")
        .attr("x1", 0)
        .attr("y1", design.ClockPieChart.RADIUS * -0.2)
        .attr("x2", 0)
        .attr("y2", -design.ClockPieChart.RADIUS)
        .attr("stroke-width", 4)
        .attr("transform", `rotate(${angle})`);

      selection
        .select(".digital-clock")
        .text(`${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`);
    };

    updateClock();
    const id = setInterval(updateClock, 1000);

    return () => clearInterval(id);
  }, []);

  return (
    <g
      ref={layerRef}
      className="clock-layer"
    />
  );
}
